<template>
  <div>
    <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">PF Settings<span>
        <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> / Settings / PF Settlement Balance Adjustment Reasons Settings</span>
    </h4>
    <div class="ibox">
      <div class="  clearfix row no-margin ibox-content mt-3">
        <div class="col-md-12 fixed-section-one mb-4">
          <div class="clearfix approval-container row">
              <div class="col-4 approve-level-label">
                <div class="approve-level-title px-0 text-left">
                  PF Settlement Balance Adjustment Reasons Settings
                </div>
                <div class="approve-level-description">
                  The Reasons defined here are those deemed by PF Trust Board to be valid
                  reasons payable to company
                  agains which Company HR may claim adjustments agains PF Member's Fund
                  Balance
                </div>
              </div>
              <div class="col-8 approve-level-content">
                <div class="clearfix px-0 border-bottom">
                  <div class="clearfix">
                    <div class="row py-2 mb-2 border-bottom">
                      <div class="col-sm-5 px-3 company-form-box-title">PF Settlement Balance Adjustment Reasons</div>
                      <div class="col-sm-4">
                        <div class="custom-search float-right w-100">
                          <b-input-group class="mb-0">
                            <b-input-group-prepend is-text>
                              <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search.." v-model="search"
                              @input="resetPagination()"></b-form-input>
                          </b-input-group>
                        </div>
                      </div>
                      <div class=" col-sm-3 text-right pr-0">
                        <b-button id="show-btn" class="mr-3" @click="addNew()"> Add New</b-button>
                      </div>
                    </div>



                    <table class="table dataTable">
                      <thead>
                        <tr class="table-head">

                          <template v-for="column in columns">

                            <th v-if="column.sort" @click="sortBy(column.name)"
                              :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                              style="cursor:pointer;"><span>{{ column.label }}</span></th>
                            <th v-else><span>{{ column.label }}</span></th>

                          </template>



                          <th class="text-right">Actions</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr class="hover-bg table-row mx-2" v-for="item in paginatedData" :key="item.id">
                          <td>{{ item.title }}</td>
                          <td>{{ item.details }}</td>
                          <td>{{ status[item.status].text }}</td>

                          <td class="text-right position-relative">
                            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                              style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                              aria-haspopup="true" aria-expanded="false"><b-icon
                                icon="three-dots-vertical"></b-icon></a>
                            <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                              <b-button-group>
                                <b-button variant="outline-secondary" @click="editData(item.id)">
                                  <b-icon icon="pencil"></b-icon> Edit
                                </b-button>
                                <b-button variant="outline-danger" @click="deleteData(item.id)">
                                  <b-icon icon="trash"></b-icon> Delete <!-- Mustafijur: 24-06-2026: icon trash -->
                                </b-button>
                              </b-button-group>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="card-body px-0 container">
                      <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                        <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                          <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled"><b-form-select v-model="temp_length"
                                :options="length_options" @change="setFirstPage()"></b-form-select></li>
                            <li class="page-item disabled m-2">per page. Total {{ paginatedData.length }} records found.
                            </li>
                          </ul>
                          <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                            :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#"
                            first-number last-number></b-pagination-nav>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="pfsettl-baladj-reason" size="lg" hide-footer title="Reason for Adjustment">
      <b-form @submit.stop.prevent="onSubmit">
        <input type="hidden" v-model="fdata.id" name="id">

        <b-form-group id="title-group" label="Reason" label-for="title">
          <b-form-input id="title" name="title" v-model="fdata.title"
            v-validate="{ required: true, min: 3, alpha_spaces: true }" :state="validateState('title')"
            aria-describedby="title-feedback" data-vv-as="Reason"></b-form-input>
          <b-form-invalid-feedback id="title-feedback">{{ veeErrors.first('title') }}</b-form-invalid-feedback>
        </b-form-group>

        <!-- Start: Rejwan: 23-04-2025 Spelling Correction -->
        <!-- <b-form-group id="details-group" label="Dscription" label-for="details">
            <b-form-input id="details" name="details" v-model="fdata.details" v-validate="{ required: true, min: 3 , alpha_spaces: true }" :state="validateState('details')" aria-describedby="details-feedback" data-vv-as="Dscription"></b-form-input> -->

        <b-form-group id="details-group" label="Description" label-for="details">
          <b-form-input id="details" name="details" v-model="fdata.details"
            v-validate="{ required: true, min: 3, alpha_spaces: true }" :state="validateState('details')"
            aria-describedby="details-feedback" data-vv-as="Description"></b-form-input>
          <!-- End: Rejwan: 23-04-2025 Spelling Correction -->
          <b-form-invalid-feedback id="details-feedback">{{ veeErrors.first('details') }}</b-form-invalid-feedback>
        </b-form-group>



        <b-form-group id="status-group" class="half-width mr1" label="Status" label-for="status">
          <b-form-select id="status" name="status" v-model="fdata.status" v-validate="{ required: true }"
            :options="status" :state="validateState('status')" aria-describedby="status-feedback"
            data-vv-as="Status"></b-form-select>
          <b-form-invalid-feedback id="status-feedback">{{ veeErrors.first('status') }}</b-form-invalid-feedback>
        </b-form-group>


        <div class="full-width my-4"> <!-- Mustafijur: 24-06-2026: mt-2 to my-4 -->
          <b-button type="submit" variant="primary">Submit</b-button> <!-- Mustafijur: 24-06-2026: variant success to primary-->

        </div>
      </b-form>

    </b-modal>
  </div>



  

</template>
<script>
export default {

  mounted() {

  },
  props: [],
  data() {

    let sortOrders = {};
    let columns = [
      { label: 'Reason', name: 'title', sort: true },
      // {label: 'Dscription', name: 'details', sort:true}, // Rejwan: 23-04-2025 spelling correction
      { label: 'Description', name: 'details', sort: true }, // Rejwan: 23-04-2025 spelling correction
      { label: 'Status', name: 'status' },
    ];
    columns.forEach((column) => { sortOrders[column.name] = -1; });

    return {

      blankmsg: 'Fetching data..',
      datalist: [],
      showoverlay: false,
      fdata: {},
      reason: 0,
      search: '',
      columns: columns,
      sortKey: 'title',
      sortOrders: sortOrders,
      length: 10,
      pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },

      status: [
        { value: "0", text: "Disabled" },
        { value: "1", text: "Enable" },
      ],
      length_options: [{ value: 10, text: "10" },{ value: 20, text: "20" },{ value: 30, text: "30" },{ value: 40, text: "40" },{ value: 50, text: "50" }],
      temp_length: 10,

    }
  },

  methods: {


    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    showDetails(id) {
      this.reason = id;
      this.$bvModal.show('pfsettl-baladj-reason-slab');
    },
    resetForm() {
      this.fdata = {};
      this.$nextTick(() => {
        this.$validator.reset();
      });
    },
    addNew() {
      this.resetForm();
      this.$bvModal.show('pfsettl-baladj-reason');
    },

    getData: function () {
      if (!this.checkNet()) return false;
      let currentObj = this;
      axios.get(this.$api_url + '/pfsettl-baladj-reason').then(function (response) {

        this.datalist = response.data;
        if (this.datalist.length == 0)
          this.blankmsg = "Nothing found.";
      }.bind(this)).catch(function (error) { currentObj.serverError(error); });
    },
    editData: function (x) {
      if (!this.checkNet()) return false;
      this.showoverlay = true;
      axios.get(this.$api_url + '/pfsettl-baladj-reason/' + x).then(function (response) {
        this.fdata = response.data;
        this.$bvModal.show('pfsettl-baladj-reason');

      }.bind(this)).catch(function (error) { currentObj.showoverlay = false; currentObj.serverError(error); });

    },
    deleteData(id) {
      if (!this.checkNet()) return false;
      let currentObj = this;

      this.$bvModal.msgBoxConfirm('Please confirm that you want to delete.', {
        title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
      })
        .then(value => {
          if (value) {
            axios.delete(this.$api_url + '/pfsettl-baladj-reason/' + id).then(function (response) {
              this.getData();
              this.showoverlay = false;

            }.bind(this))
              .catch(function (error) {

                currentObj.showoverlay = false;
                currentObj.serverError(error);
              });
          }
        })
        ;
    },


    onSubmit(e) {
      if (!this.checkNet()) return false;

      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }
        this.showoverlay = true;

        e.preventDefault();
        let currentObj = this;

        let formData = new FormData();

        for (let [key, value] of Object.entries(this.fdata)) {
          var nm = `${key}`;
          var fval = `${value}`;
          formData.append(nm, fval);
          //console.log(`${key}: ${value}`);
        }

        var url = this.$api_url + '/pfsettl-baladj-reason';

        if (this.fdata.id > 0) {
          url = url + '/' + this.fdata.id + '?_method=PUT';
        }

        axios.post(url, formData)
          .then(function (response) {
            this.getData();
            this.$bvToast.toast('Saved!', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
            this.showoverlay = false;
            this.resetForm();
            this.$bvModal.hide('pfsettl-baladj-reason');

          }.bind(this))
          .catch(function (error) {
            this.showoverlay = false;
            currentObj.serverError(error);
          });


      });
    },



  },
  created: function () {

    this.getData();
    Fire.$on('reloadData', () => { this.getData() });
  },


  computed:
  {
    filteredData() {
      let filtered_list = this.datalist;
      if (this.search) {
        filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });

        if (filtered_list.length == 0)
          this.blankmsg = "Nothing found.";
      }

      let sortKey = this.sortKey;
      let order = this.sortOrders[sortKey] || 1;
      if (sortKey) {
        filtered_list = filtered_list.slice().sort((a, b) => {
          let index = this.getIndex(this.columns, 'name', sortKey);
          a = String(a[sortKey]).toLowerCase();
          b = String(b[sortKey]).toLowerCase();
          if (this.columns[index].type && this.columns[index].type === 'date') {
            return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
          }
          else if (this.columns[index].type && this.columns[index].type === 'number') {
            return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
          }
          else {
            return (a === b ? 0 : a > b ? 1 : -1) * order;
          }
        }
        );
      }

      return filtered_list;
    },
    paginatedData() {
      return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
    },


  }
}
</script>
